<template>
  <div class="loggedin-navigation">
    <ul>
      <li v-for="item in store.flatNavigation" :key="item.id">
        <router-link :to="{ name: item.to }">{{ item.label }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useMenuStore } from '@/stores/menu'
const store = useMenuStore()
</script>
